import { dialog, FormFactory, InputFactory } from "../../../../../../nq-component";
import { useEffect, useState } from "react";
import schema from "./schema.json";

function RecordDialogForm({ index, object, handleSubmit }) {
  const [updatedObject, setUpdatedObject] = useState({
    company: object?.company || "",
    caseNumber: object?.caseNumber || "",
    firstName: object?.firstName || "",
    middleName: object?.middleName || "",
    lastName: object?.lastName || "",
    alias: object?.alias || "",
    ...object,
  });

  useEffect(() => {
    console.log(updatedObject);
  }, [updatedObject]);

  const _onChange = (value, field) => {
    setUpdatedObject((prev) => ({ ...prev, [field]: value }));
  };

  const _handleSubmit = (e) => {
    e.preventDefault();
    handleSubmit(index, updatedObject);
  };
  return (
    <>
      <div className="m-0 card bg-white p-3">
        <div className="d-flex flex-column">
          <div style={{ borderBottom: "1px solid gray" }}>
            <p className="mb-1 fw-bold" style={{ fontSize: "0.9rem" }}>
              {object ? "Update" : "Add"} Details
            </p>
          </div>
          <form onSubmit={_handleSubmit}>
            <FormFactory
              schema={schema}
              object={updatedObject}
              onChange={_onChange}
            />
            <div className="d-flex gap-2 mt-3">
              <button
                type="button"
                className="btn w-100"
                onClick={() => dialog.close()}
                style={{ backgroundColor: "#D1D1D1" }}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary w-100">
                {object ? "Update" : "Add"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default RecordDialogForm;
